// src/stone/illustrations/PosNfcIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var PosNfcIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("rect", { width: 64, height: 64, fill: "#E8FEF3", rx: 4 }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M36.775 48.647c-1.258.394-2.529.79-3.843.889-1.313.098-2.694-.126-3.773-.883-1.078-.758-1.786-2.11-1.54-3.403"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M32.346 49.71c-.993 0-2.222-.193-3.277-.933-1.202-.843-1.846-2.272-1.602-3.556a.15.15 0 0 1 .178-.12.153.153 0 0 1 .122.177c-.223 1.168.371 2.474 1.478 3.25 1.204.845 2.662.932 3.674.857 1.303-.102 2.576-.497 3.807-.884a.153.153 0 0 1 .177.215.15.15 0 0 1-.086.075c-1.248.392-2.538.796-3.876.897a8 8 0 0 1-.595.022"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M51.519 25.755c-1.616 2.332-5.17 5.688-6.512 7.963L33.592 56.162c-.692 1.171-2.29 1.712-3.572 1.207l-7.704-3.042 15.93-40.179 10.661 4.207c3.127 1.232 4.294 4.544 2.612 7.4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M41.492 20.98 22.316 54.332l7.704 3.041c1.281.507 2.88-.034 3.57-1.206l11.42-22.449zM45.064 31.157a.15.15 0 0 1-.149-.12l-2.162-9.845a.152.152 0 0 1 .297-.065l2.162 9.846a.153.153 0 0 1-.117.18.1.1 0 0 1-.031.004"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M29.035 53.956 43.7 16.299l-11.49-4.531c-2.842-1.122-6.385.337-7.469 3.077L11.86 47.999c-.428 1.101.097 2.243 1.238 2.692l12.2 4.812c1.426.566 3.202-.171 3.738-1.547"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m31.325 43.399 5.562-14.327c.203-.506-.073-1.042-.648-1.268l-11.391-4.48c-.711-.28-1.58.028-1.828.65l-5.56 14.327c-.202.507.074 1.042.649 1.27l11.389 4.479c.71.28 1.577-.029 1.827-.651"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m41.796 15.549 7.349 2.898c-2.843-1.122-6.386.337-7.47 3.078l-1.234-3.687z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m13.81 47.189 2.41-5.864c.203-.507.777-.71 1.35-.485l11.372 4.46c.71.28 1.124 1.093.874 1.717l-2.41 5.863c-.202.507-.776.71-1.35.485l-11.367-4.46c-.715-.28-1.13-1.093-.88-1.716"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m14.871 42.488-.111.284 15.255 5.988.111-.283zM14.178 45.614l-.112.284 9.911 3.89.111-.283z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m26.2 43.834-3.63 8.69.281.117 3.63-8.69zM20.822 41.724l-3.63 8.69.28.116 3.631-8.689zM39.07 24.106l1.755-4.003c.399-.913-.212-1.967-1.41-2.44l-9.81-3.869c-1.366-.538-2.944-.107-3.396.931"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M39.07 24.258a.14.14 0 0 1-.061-.013.15.15 0 0 1-.08-.203l1.756-4.003a1.3 1.3 0 0 0 0-1.05c-.203-.506-.691-.937-1.326-1.187l-9.81-3.869c-1.283-.507-2.78-.11-3.2.85a.153.153 0 0 1-.282-.005.15.15 0 0 1 .002-.117c.493-1.122 2.138-1.584 3.593-1.014l9.809 3.87c.71.28 1.256.773 1.495 1.354a1.6 1.6 0 0 1 0 1.288l-1.755 4.002a.15.15 0 0 1-.141.097"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#E8E9EA", d: "M43.93 8.656h-.006v-.004z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E8E9EA",
          d: "M50.37 13.216S38.736 11.26 37.138 26.904v.026l-11.88-4.684-.57-.224c-.2-12.458 9.162-16.96 15.665-15.23l.013.007-.087 1.06 3.645.798-.078 1.07 3.603.767h.008l-.061 1.14z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M37.13 27.085a.2.2 0 0 1-.056-.012l-12.447-4.909a.15.15 0 0 1-.1-.14.15.15 0 0 1 .094-.143.15.15 0 0 1 .118 0l12.451 4.91a.152.152 0 0 1-.056.293zM43.93 8.656h-.006v-.008h.003z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M43.93 8.656h-.006v-.008h.003zM27.434 38.848a.508.508 0 0 1-.305-.913c2.437-1.811 3.471-4.222 3.167-7.37a.506.506 0 0 1 .826-.443.5.5 0 0 1 .184.342c.337 3.48-.864 6.267-3.571 8.28a.5.5 0 0 1-.302.104"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M25.934 37.368a.508.508 0 0 1-.305-.912c1.952-1.452 2.783-3.386 2.538-5.91a.506.506 0 0 1 .827-.442c.104.085.17.208.183.341.279 2.867-.71 5.161-2.944 6.82a.5.5 0 0 1-.3.103"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M24.82 35.455a.508.508 0 0 1-.304-.912c1.218-.904 1.73-2.107 1.578-3.68a.508.508 0 0 1 1.01-.102c.188 1.926-.48 3.474-1.981 4.59a.5.5 0 0 1-.303.104M23.486 34.053a.508.508 0 0 1-.304-.912c.756-.563 1.078-1.318.982-2.297a.511.511 0 0 1 1.016-.101c.134 1.35-.338 2.428-1.39 3.215a.5.5 0 0 1-.304.095"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8F5049",
          d: "m19.422 44.773-.02.108v-.049zM18.193 49.555v.008l-.012.012z"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#8F5049", d: "M18.193 49.555v.008l-.012.012z" })
    ]
  }
);
var PosNfcIllustration_default = PosNfcIllustration;

export {
  PosNfcIllustration,
  PosNfcIllustration_default
};
